// @ts-nocheck
import { Link, Outlet, useLoaderData, useLocation } from "react-router-dom";

import ServerFooter from "../common/ServerFooter";
import UserInfo from "../common/userInfo";

export default function Fleets() {
    const { fleets, total } = useLoaderData();
    const location = useLocation();

    return (
        <div className={"cssContent" + (total > 0 ? " pb8rem" : "")}>
            <nav className="mt-2 d-flex flex-wrap align-items-center gap-2">
                <Link className="btn btn-outline-primary" to="Settings">
                    Settings
                </Link>
                <Link className="btn btn-outline-primary" to="Yards">
                    Yards
                </Link>
                <Link className="btn btn-outline-primary" to="Yard">
                    Yard Items
                </Link>
                <Link className="btn btn-outline-primary" to="Inventory">
                    Inventory
                </Link>
                <Link
                    className="btn btn-outline-primary ms-auto"
                    to={{ pathname: "Add", search: location.search }}
                >
                    Add
                </Link>
            </nav>
            {!fleets.length ? (
                <div className="cssLoading">Empty</div>
            ) : (
                <div className="table-responsive">
                    <table className="table">
                        <thead className="noTableTopBorder">
                            <tr>
                                <th>Truck #</th>
                                <th>Type</th>
                                <th>Open</th>
                                <th>Creator</th>
                                <th>Date Created</th>
                                <th>Updater</th>
                                <th>Date Updated</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {fleets.map(fleet => (
                                <tr key={fleet.id}>
                                    <td>{fleet.truckNumber}</td>
                                    <td>{fleet.type}</td>
                                    <td>{fleet.open}</td>
                                    <td>
                                        {fleet.creatorId ? (
                                            <UserInfo id={fleet.creatorId} name={fleet.creator} />
                                        ) : null}
                                    </td>
                                    <td>{fleet.dateCreated}</td>
                                    <td>
                                        {fleet.updaterId ? (
                                            <UserInfo id={fleet.updaterId} name={fleet.updater} />
                                        ) : null}
                                    </td>
                                    <td>{fleet.dateUpdated}</td>
                                    <td>
                                        <Link className="btn btn-outline-primary" to={String(fleet.id)}>
                                            Detail
                                        </Link>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            {total > 0 ? <ServerFooter length={total} /> : null}
            <Outlet />
        </div>
    );
}
